import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { changeFactorTypeToRevoke, changeFactorTypeToRevokeOrReturn } from "../../../api/requestAxios/invoice"
import constants from "../../../constants/constants"
import CustomValuesHook from "../../../functions/myHooks/CustomValuesHook"
import { ErrorToast, InfoToast } from "../../../shared"
import ModalLoader from "../modalLoader"
import btnClose from "../../../assets/images/svg/close_modal_icon.svg";
import { makeStyles } from '@material-ui/core/styles';
import './style.scss'
import { Tooltip } from "@material-ui/core"
import { ErrorSvg } from "../../../assets/images/svg/errorSvg"
import { isNumber } from "../../../functions/extensions/regexModel"
import { enToPersianChar } from "../../activities"
import { CommaSeparator, toEnglishNumber, ToPersianNumber } from "../../../functions"


const ChangeReturnRevoke = ({
    item,
}) => {
    const useStyles = makeStyles({
        tooltip: {
            background: '#333',
            borderRadius: '20px ',
            color: '#FFF',
            padding: '8px 15px',
            fontSize: '14px'
        },
    });


    const classesToolTip = useStyles();
    const [changeType, handleChangeType] = CustomValuesHook({
        value: '',
        loading: false,
        itemClick: '',
        modalHeader: '',
        showModal: false,
        amount: '',
        isTotalAmount: true,
        isReturned: false,
        isRevoked: false
    })

    useEffect(() => {
        if (item.Revoked) handleChangeType({ value: 'REVOKE' })
        if (item?.IsReturn) handleChangeType({ value: 'RETURN' })
        handleChangeType({ isReturned: false, isRevoked: false })
    }, [item])
    //**************************************************************************************** */
    const changeFactorTypeToRevokeFun = async () => {
        handleChangeType({ loading: true })
        try {
            let temp = {
                OfficialFactorId: item?.OfficialFactorId,
                Revoked: true
            }

            const changeFactorTypeResult = await changeFactorTypeToRevokeOrReturn(temp)
            if (changeFactorTypeResult?.data?.IsSuccess) {
                InfoToast('فاکتور با موفقیت ابطال شد')
                handleChangeType({ showModal: false, isRevoked: true })
            }
            else {
                InfoToast('ابطال فاکتور با مشکل مواجه شد')

            }
            handleChangeType({ loading: false })
        }
        catch (err) {
            ErrorToast(err)
            handleChangeType({ loading: false })
        }

    }
    //****************************************************************************************** */
    const changeFactorTypeToReturnFn = async () => {
        handleChangeType({ loading: true })
        try {
            let temp = {
                OfficialFactorId: item?.OfficialFactorId,
                OfficialFactorType: 3,
                TotalAmountReservedOrReturned: changeType?.isTotalAmount ? item?.PayableAmount : toEnglishNumber(changeType?.amount)
            }
            const changeFactorTypeResult = await changeFactorTypeToRevokeOrReturn(temp)
            if (changeFactorTypeResult?.data?.IsSuccess) {
                InfoToast('فاکتور با موفقیت برگشت شد')
                handleChangeType({ showModal: false, isReturned: true })
            }
            else {
                InfoToast('برگشت فاکتور با مشکل مواجه شد')
            }
            handleChangeType({ loading: '' })
        }
        catch (err) {
            ErrorToast(err)
            handleChangeType({ value: '', loading: false })

        }

    }
    const changeStatus = () => {
        if (changeType.value === 'REVOKE') {
            changeFactorTypeToRevokeFun()
        } else if (changeType.value === 'RETURN') {
            if (!changeType?.isTotalAmount) {
                if (toEnglishNumber(changeType?.amount) && isNumber(toEnglishNumber(changeType?.amount))) {
                    changeFactorTypeToReturnFn()
                }
                else {
                    ErrorToast('وارد کردن مبلغ الزامی است')
                }
            }
            else {
                changeFactorTypeToReturnFn()
            }

        }

    }



    //****************************************************************************************** */
    return (
        <div className="change-type-invoice">
            {(item?.Revoked || changeType?.isRevoked) && <label className="return-revoke-lbl">ابطال</label>}
            {(item?.IsReturn || changeType?.isReturned) && <label className="return-revoke-lbl">برگشتی</label>}
            {!item?.Revoked && !item?.IsReturn && !changeType?.isReturned && !changeType?.isRevoked && <select
                onChange={(e) => handleChangeType({ value: e.target.value, showModal: true })}
                value={changeType?.value}

            >
                <option value={''} >انتخاب کنید</option>
                <option value={'RETURN'} >برگشت</option>
                <option value={'REVOKE'} >ابطال</option>

            </select>}

            <Modal show={changeType?.showModal} onHide={() => handleChangeType({ showModal: true })} animation={true} dir="rtl" className=" change-type-modal">
                <Modal.Body className='invoice-modal-content-view'>
                    <div className="">
                        <div className="d-flex justify-content-between w-100">
                            <div className="d-flex justify-content-center header-change-factor">
                                <span className="title-modal"> {changeType?.value === 'RETURN' ? 'برگشت فاکتور به ' : 'ابطال فاکتور به'}</span>
                                <span className="title-modal-number"> شماره فاکتور</span>
                                <span className="title-modal-number">{item?.InvoiceNumberInFactorFa}</span>
                            </div>
                            <div className="close-section">
                                <img
                                    onClick={() => handleChangeType({ showModal: false, isTotalAmount: true, amount: '', value: '' })}
                                    alt={'info'}
                                    src={btnClose}
                                />
                            </div>

                        </div>
                        <div className="d-flex justify-content-between m-3">
                            <span>مشترک</span>
                            <span>{item?.FirstNameAndLastName}</span>
                        </div>
                        <div className="d-flex justify-content-between m-3">
                            <span>تاریخ تراکنش</span>
                            <span>{item?.PersianIssueDateFa}</span>
                        </div>
                        <div className="d-flex justify-content-between m-3">
                            <span>مبلغ تراکنش</span>
                            <span>{item?.PayableAmountFa}</span>
                        </div>

                        {changeType?.value === 'RETURN' &&
                            <div className="select-amount m-3">
                                <div className="d-flex justify-content-start align-items-center" onClick={() => handleChangeType({ isTotalAmount: true })}>
                                    <div className={` check-radio ${changeType?.isTotalAmount ? 'selected' : ''}`}></div>
                                    <span>کل مبلغ</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center return-amount">
                                    <div className="d-flex justify-content-start align-items-center"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            handleChangeType({ isTotalAmount: false })
                                        }}>
                                        <div className={`check-radio  ${!changeType?.isTotalAmount ? 'selected' : ''}`}></div>
                                        <span>مبلغ بازگشتی</span>
                                    </div>
                                    <div>

                                        {!changeType?.isTotalAmount && <input
                                            className="change-amount-input"
                                            value={changeType?.amount ? enToPersianChar(changeType?.amount) : changeType?.amount}
                                            onChange={(e) => { handleChangeType({ amount: e.target.value }) }}
                                            type="text"
                                            placeholder="مقدار مبلغ برگشت داده شده را وارد کنید"
                                        />}
                                        {!changeType?.isTotalAmount && (!isNumber(toEnglishNumber(changeType?.amount)) || toEnglishNumber(changeType?.amount) > item?.PayableAmount) && <Tooltip classes={classesToolTip} title={'مبلغ  را به صورت عدد و کوچکتر از مبلغ کل وارد کنید'} >
                                            <span className='error-input'><ErrorSvg /></span>
                                        </Tooltip>}

                                    </div>

                                </div>

                            </div>}
                        <div className="d-flex justify-content-center  get-confirm-txt">
                            {`${changeType?.value !== 'RETURN' ? 'آیا مایل به ابطال این فاکتور هستید؟' : 'آیا مایل به برگشت این فاکتور می‌باشید؟'}`}</div>

                        <div className="d-flex justify-content-between">
                            <button
                                className="btn-confirm  btn-confirm-ok"
                                onClick={changeStatus}
                                disabled={changeType?.loading || (!isNumber(toEnglishNumber(changeType?.amount)) || toEnglishNumber(changeType?.amount) > item?.PayableAmount)}
                            >بله</button>
                            <button
                                className="btn-confirm   btn-confirm-cancel "
                                onClick={() => handleChangeType({ showModal: false, isTotalAmount: true, amount: '', value: '' })}> خیر</button>
                        </div>
                    </div>
                </Modal.Body>



            </Modal>
        </div>
    )
}
export default ChangeReturnRevoke